import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import { useDataValue, useDataChange, useDataSubmit } from 'Simple/Data.js'
import { useClient } from 'Data/Api.js'
import query from './query.graphql.js'

export function useOnSubmit(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)
  let client = useClient()

  let letter = useDataValue({
    context: 'letter',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'letter',
    viewPath: props.viewPath,
  })

  let submit = useDataSubmit({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return async function onSubmit(action) {
    if (letter.document_node_id) {
      try {
        let { data } = await client
          .query(query, { resource_id: letter.document_node_id })
          .toPromise()

        change(next => {
          next.is_finalized =
            data?.vaxiom_resource_object_meta?.content_type ===
            'application/pdf'
        })
      } catch (error) {
        console.error('Query error:', error)
      }
    }

    submit(action)

    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
